import React, { FC } from "react";
import { FullscreenFallback } from "../DialogComponents/DialogFallback/FullscreenFallback";
import { useContext } from "./hooks/useContext";

export const TableReferences: FC = () => {
  const context = useContext();

  return <FullscreenFallback context={context} />;
};
